export default __webpack_public_path__ + "static/media/heading.75b59ba6.png";